export function useDrawerUtils() {
  function clamp(value, from, to) {
    if (from > to) {
      if (value > from) return value;
      if (value < to) return to;
      else return value;
    } else if (from < to) {
      if (value < from) return value;
      if (value > to) return to;
      else return value;
    } else {
      if (value < to) return to;
      else return value;
    }
  }
  return {
    clamp
  };
}
